import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import marriottgxp from 'img/pms/marriottgxp.png'

import FAQCard from './FAQ'
import GXPCredentialsForm from './GXPCredentialsForm'
import styles from './GXPLogin.module.scss'
import { GXPLoginProvider, useGXPLogin } from './GXPLoginContext'
import ReportsCreationStep from './ReportsCreationStep'
import UserGeneratedStep from './UserGeneratedStep'
import UserGettingRegionalAccessStep from './UserGettingRegionalAccessStep'
import UserSetupStep from './UserSetupStep'
import UserWaitingApprovalStep from './UserWaitingApprovalStep'

const STEPS = [
  { key: 'UserGenerated', title: 'Request GXP login' },
  { key: 'UserWaitingApproval', title: 'Waiting for EID approval' },
  { key: 'UserGettingRegionalAccess', title: 'User setup' },
  { key: 'ReportsCreating', title: 'Waiting for regional access' },
  { key: 'Completed', title: 'Reports creation' }
]

export default function GXPLogin() {
  return (
    <GXPLoginProvider>
      <GXPLoginWithContext />
    </GXPLoginProvider>
  )
}

function GXPLoginWithContext() {
  const { isLoading, data } = useGXPLogin()

  if (isLoading) return <LoadingIndicator />

  if (data.activeStep === 60 || data.activeStep === 'Finalized') {
    return <GXPCredentialsForm />
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.cardLeft}>
          <img src={marriottgxp} alt="PMS Marriotgxp" />
          <div className={styles.steps}>
            {STEPS.map((step, index) => (
              <div
                key={step.key}
                className={`${styles.step} ${
                  step.key === data.activeStep ? styles.activeStep : ''
                }`}
              >
                {index + 1}. {step.title}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.cardRight}>
          {data.activeStep === 'UserGenerated' ? (
            <UserGeneratedStep />
          ) : data.activeStep === 'UserWaitingApproval' ? (
            <UserWaitingApprovalStep />
          ) : data.activeStep === 'UserGettingRegionalAccess' ? (
            <UserSetupStep />
          ) : data.activeStep === 'ReportsCreating' ? (
            <UserGettingRegionalAccessStep />
          ) : data.activeStep === 'Completed' ? (
            <ReportsCreationStep />
          ) : null}
        </div>
      </div>
      {(data.activeStep === 'UserWaitingApproval' ||
        data.activeStep === 'UserGettingRegionalAccess' ||
        data.activeStep === 'Completed') && <FAQCard selectedStep={data.activeStep} />}
    </div>
  )
}
